import React from 'react';
import './Modal.css';

// Modal genérico para feedback ao usuário (sucesso, erro de validação, avisos).
// Substitui os alert() nativos por um popup no mesmo padrão visual do painel admin.
const ModalMessage = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-card blue-theme">
        <button className="btn-close-modal" onClick={onClose}>&times;</button>
        <p className="modal-message">{message}</p>
      </div>
    </div>
  );
};

export default ModalMessage;
